<template>
  <div class="sub-routes">
    <section class="app-section"
             v-loading="loading"
             id="createNewObject_o">
      <el-form :inline="true"
               :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               class="demo-form-inline">
        <el-row style="padding:20px;padding-top:12px;">
          <h3 class="creat-type-tit_o">
            <span class="shuxian_o"></span> 基本信息
          </h3>
          <el-row>
            <el-col :span="7">
              <el-form-item prop="name"
                            label="随访名称">
                <el-input v-model="ruleForm.name"
                          maxlength="20"
                          placeholder="请输入随访名称"></el-input>

              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-form-item prop="name"
                            label="内容类型">
                <el-select v-model="ruleForm.contentType"
                           @change='getContentType'
                           filterable
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in externalDdata.content"
                             :key="ind"
                             :label="val.value"
                             :value="val.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="contents"
                            v-if="!showOnePage"
                            label="内容选择">
                <el-input v-model="ruleForm.contents"
                          clearable
                          @focus="contentSelect"
                          maxlength="20"
                          placeholder="请输入随访名称"></el-input>

              </el-form-item>

            </el-col>
            <el-col :span="7">
              <el-form-item prop="contents"
                            v-if="showOnePage"
                            label="内容选择">
                <el-input v-model="ruleForm.contents"
                          clearable
                          @focus="contentSelect"
                          maxlength="20"
                          placeholder="请输入内容选择"></el-input>

              </el-form-item>
            </el-col>
          </el-row>
          <h3 class="creat-type-tit_o">
            <span class="shuxian_o"></span> 筛查条件
          </h3>
          <!-- <el-row v-if="!showOnePage">
            <el-col :span="22">

              <div class="namebox">
                <span style="color:#606266;padding:0 10px">所选人员</span>
                <span v-for="(val,ind) in  editData.patient_filter_entity_list"
                      style="padding: 0px 6px;"
                      :key="ind">{{val.name}}</span>

              </div>

            </el-col>
          </el-row> -->

          <el-row v-if="selectTypeCode=='1280309721538105333'">
            <el-col v-if="selectTypeCode=='1280309721538105333'&&showOnePage "
                    :span="7">
              <el-form-item label="所属分组"
                            class="padleft">
                <el-select v-model="group"
                           clearable
                           filterable
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in groupList"
                             :key="ind"
                             :label="val.name"
                             :value="val.id"></el-option>
                </el-select>

              </el-form-item>
            </el-col>

            <el-col :span="7"
                    v-show="group!=0"
                    v-if="selectTypeCode=='1280309721538105333'&&showOnePage">
              <el-form-item label="入组时间">
                <el-date-picker v-model="Chronic"
                                type="daterange"
                                style='width:219px'
                                align="right"
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.ChronicOptions">
                </el-date-picker>

              </el-form-item>
            </el-col>

          </el-row>
          <el-row>

            <el-col :span="10"
                    v-if="showFollowObj">
              <el-form-item label="随访对象"
                            prop="task_follow">
                <el-select v-model="ruleForm.task_follow"
                           filterable
                           multiple
                           style='min-width:px'
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in  followUpObj"
                             :key="ind"
                             :label="val.follow_person_name"
                             :value="val.follow_person_code"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="7"
                    v-if="selectTypeCode=='1280309721538105355'&&showOnePage">
              <el-form-item label="筛查问卷"
                            class="padleft">
                <el-input v-model="Radiovalue2.value"
                          @focus="groupSelect"
                          clearable
                          maxlength="20"
                          placeholder="请选择"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10"
                    v-if="selectTypeCode=='1280309721538105355'&&showOnePage">
              <el-form-item label="筛查时间"
                            class="padleft">
                <el-date-picker v-model="groupTime"
                                style='width:219px'
                                type="daterange"
                                align="right"
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.groupTimeOptions">
                </el-date-picker>

              </el-form-item>
            </el-col>
            <el-col :span="7"
                    v-if="selectTypeCode=='1280309721538105333'&&showOnePage">
              <el-form-item label="所属标签"
                            class="padleft">
                <el-select v-model="ruleForm.tag"
                           filterable
                           multiple
                           style='width:219px'
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in  tagList"
                             :key="ind"
                             :label="val.name"
                             :value="val.id"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="7"
                    v-if="selectTypeCode=='1280309721538105333'&&showOnePage ">
              <el-form-item label="评估"
                            style="padding-left:36px">
                <el-select v-model="invisible_group_ids"
                           filterable
                           multiple
                           style='min-width:217px'
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in  invisible_group"
                             :key="ind"
                             :label="val.name"
                             :value="val.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7"
                    v-if="selectTypeCode=='1280309721538105333'&&showOnePage ">
              <el-form-item label="签约状态"
                            class="padleft">
                <el-select v-model="ruleForm.signStatus"
                           filterable
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in externalDdata.signStatusList"
                             :key="ind"
                             :label="val.value"
                             :value="val.code"></el-option>
                </el-select>

              </el-form-item>
            </el-col>

          </el-row>

          <el-row v-if="selectTypeCode=='1280309721538105355'&&showOnePage">
            <el-col :span="7">
              <el-form-item label="所属分组"
                            class="padleft">
                <el-select v-model="group"
                           clearable
                           filterable
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in groupList"
                             :key="ind"
                             :label="val.name"
                             :value="val.id"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="入组时间"
                            v-show="group!=0"
                            class="padleft">
                <el-date-picker v-model="Chronic"
                                type="daterange"
                                align="right"
                                style='width:219px'
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="externalDdata.ChronicOptions">
                </el-date-picker>

              </el-form-item>
            </el-col>

          </el-row>
          <el-row v-if="selectTypeCode=='1280309721538105355'&&showOnePage">
            <el-col :span="7">
              <el-form-item label="所属标签"
                            class="padleft">
                <el-select v-model="ruleForm.tag"
                           filterable
                           multiple
                           style='min-width:px'
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in  tagList"
                             :key="ind"
                             :label="val.name"
                             :value="val.id"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="评估"
                            style="padding-left:36px">
                <el-select v-model="invisible_group_ids"
                           filterable
                           multiple
                           style='min-width:217px'
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in  invisible_group"
                             :key="ind"
                             :label="val.name"
                             :value="val.id"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="selectTypeCode=='1280309721538105355'&&showOnePage">
            <el-col :span="7">

              <el-form-item label="性别"
                            style="padding-left:36px">
                <el-select v-model="ruleForm.sex"
                           placeholder="请选性别">
                  <el-option v-for="(item, index) in externalDdata.sexList"
                             :key="index"
                             :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="7">
              <el-form-item label="年 龄 段"
                            style="padding-left:16px">
                <input type="number"
                       v-model="age1"
                       style="width:104px"
                       @keyup="proving1($event)"
                       class="ckinput"
                       oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                       min="1"
                       placeholder="岁" />
                <input style="margin-left:13px;width:104px"
                       type="number"
                       v-model="age2"
                       oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                       placeholder="岁"
                       @keyup="proving1($event)"
                       class="ckinput"
                       min="1" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否确诊"
                            class="padleft">
                <el-select v-model="diagnosis"
                           style="width: 217px"
                           filterable
                           placeholder="请选择">
                  <el-option v-for="(val, ind) in externalDdata.diagnosis"
                             :key="ind"
                             :label="val.label"
                             :value="val.value"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="showFollowObj">
            <el-col :span="10">
              <span class="sp_left"></span>
              <el-form-item label="隐私选择">
                <el-checkbox-group v-model="checkList">
                  <el-checkbox label="隐藏姓名"></el-checkbox>
                  <el-checkbox label="隐藏电话"></el-checkbox>
                  <!-- <el-checkbox label="隐藏地址"></el-checkbox> -->
                  <el-checkbox label="隐藏答卷"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="showFollowObj">
            <span class="sp_left"></span>
            <el-form-item label="备注">
              <el-input type="textarea"
                        :rows="3"
                        placeholder="简单描述该随访的目标，范围等，包括对随访执行的特殊需求"
                        v-model="remark"
                        maxlength="70"
                        show-word-limit
                        style="width: 1030px;padding-left:26px"></el-input>
            </el-form-item>
          </el-row>
          <ImportExcel @sendObjList="getObjList"
                       :excel_temp_entities="excel_temp_entities"
                       v-if='falg2' />
        </el-row>
        <el-row style="padding:20px ;padding-top:12px ">
          <h3 class="creat-type-tit_o">
            <span class="shuxian_o"></span>
            更多设置
          </h3>
          <el-row>
            <el-col :span="8">
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 20px">

            <el-col :span="7">

              <el-form-item prop="executionTime"
                            label="执行时间">
                <el-date-picker v-model="ruleForm.executionTime"
                                type="daterange"
                                align="right"
                                style='width:219px'
                                unlink-panels
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                :picker-options="externalDdata.executionTime">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="run_type"
                            style="padding-left:18px"
                            label="执行方式">
                <el-select v-model="ruleForm.run_type"
                           @change="types(ruleForm.run_type)">
                  <el-option v-for="(val, ind) in externalDdata.executeType"
                             :key="ind"
                             :label="val.value"
                             :value="val.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row v-show="ruleForm.run_type == 0||ruleForm.run_type==3 " style="margin-bottom: 30px">
            <el-col :span="6">
              <el-form-item 
                            label="重复次数">
                <el-select v-model="ruleForm.frequency">
                  <el-option v-for="index of 5"
                             :key="index"
                             :value="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-if="ruleForm.frequency!=1"
                            style="padding-left: 28px;"
                            label="推送间隔">
                <el-select style="width:210px"
                           v-model="ruleForm.push_interval">
                  <el-option v-for="index of 5"
                             :key="index"
                             :value="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item v-if="ruleForm.frequency!=1"
                            style="padding-left: 8px;"
                            label="间隔单位">
                <el-select v-model="ruleForm.interval_unit"
                           @change="setInterval_unit(ruleForm.interval_unit)">
                  <el-option v-for="(val, ind) in externalDdata.unitL"
                             :key="ind"
                             :label="val.value"
                             :value="val.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
          <span v-show="ruleForm.run_type == 0||ruleForm.run_type==3"
                class="tipsty2">* 患者如未响应，系统将每隔{{ruleForm.push_interval}}{{interval_unit}}推送一次问卷，一共推送{{ruleForm.frequency}}次</span>
          <el-row v-show="ruleForm.run_type == 0||ruleForm.run_type==3"
                  style="margin-top:0;">

            <el-col :span="6">
              <el-form-item prop="valueTime"
                            label="推送时间">
                <el-time-select v-model="ruleForm.valueTime"
                                :picker-options="externalDdata.timeLimit"
                                style="width:200px"
                                format="HH:mm"
                                placeholder="时间"></el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="duplicate"
                            label="计划推送人数">
                <input style="width:210px;height:40px"
                       type="number"
                       v-model.number="ruleForm.total_num"
                       oninput="if(this.value=='00'){this.value='0';}else{this.value=this.value.replace(/[^0-9]/g,'')};"
                       placeholder="请输入"
                       class="ckinput"
                       min="1" />

              </el-form-item>
              <span v-show="ruleForm.run_type == 0||ruleForm.run_type==3"
                    class="tipsty">* 计划推送人数为空，则每天推送人数为全部；不为空，每天推送人数为计划推送人数/任务天数</span>
            </el-col>

          </el-row>
        </el-row>
        <el-row style="padding:20px ;padding-top:12px">
          <h3 class="creat-type-tit_o">
            <span class="shuxian_o"></span>
            完成标准
            <el-button round
                       type="primary"
                       style="background: #4286f1;"
                       class="addStandard"
                       @click="addStandard">添加标准</el-button>
          </h3>

          <div v-for="(val, ind) in optionsList"
               :key="ind"
               :inline="true"
               class="demo-form-inline">
            <el-row class="dimension_o">
              <span style="color: #F56C6C">*</span>
              <el-form-item label="参考维度">
                <el-select v-model="val.dimension_code"
                           style="width:200px; margin-top: 14px;"
                           @change="getChangeVal(ind, val, $event)">
                  <el-option v-for="(value, index) in val.select"
                             :key="index"
                             :disabled="value.disabled"
                             :label="value.label"
                             :value="value.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="目标数值"
                            style="padding-left: 10px;"
                            v-show="val.dimension_code != 'ANSWER_PERCENT'">
                <input v-model.number="val.dimension_value"
                       class="ckinput"
                       type="number"
                       min="1"
                       style=" outline-color:#4286f1;margin-top: 14px"
                       @keyup="proving1($event)"
                       placeholder="请输入" />
              </el-form-item>
              <el-form-item v-show="val.dimension_code == 'ANSWER_PERCENT'"
                            style="padding-left: 10px;"
                            label="目标数值">
                <input v-model="val.dimension_value"
                       class="ckinput"
                       style=" outline-color:#4286f1;margin-top: 14px"
                       placeholder="请输入"
                       @keyup="val.dimension_value = oninput(val.dimension_value)" />

                <span class="PERCENT">%</span>
              </el-form-item>

              <i class="el-icon-error elerror"
                 v-show="ind"
                 @click="delet(ind)"></i>
            </el-row>
          </div>
          <channel @sendChannelData="getChannelData"
                   v-if='flag'
                   :channel_requests='channel_requests'
                   @sendcheck='getcheck'
                   ref="mychild" />

        </el-row>
        <div style="text-align: center;width: 100%; margin-top:30px;padding-bottom: 50px; ">
          <el-button round
                     v-if="showFollowObj&&status_code==0"
                     class="subBtn"
                     @click="saveBtn('0', 'ruleForm')"
                     type="primary"
                     style="background: #4286f1;">保存草稿</el-button>
          <el-button round
                     v-if="showFollowObj"
                     v-show="status_code==0||status_code==1"
                     class="subBtn"
                     type="primary"
                     style="background: #4286f1;"
                     @click="saveBtn('1', 'ruleForm')">保存并开始</el-button>

          <el-button round
                     v-if="!showFollowObj&&status_code==0"
                     class="subBtn"
                     type="primary"
                     style="background: #4286f1;"
                     @click="spareBtn(0,'ruleForm',)">保存草稿</el-button>
          <el-button round
                     v-if="!showFollowObj"
                     v-show="status_code==1"
                     class="subBtn"
                     type="primary"
                     style="background: #4286f1;"
                     @click="spareBtn(1,'ruleForm',)">&nbsp;保&nbsp;&nbsp;&nbsp;存&nbsp;</el-button>
          <el-button round
                     v-if="!showFollowObj"
                     v-show="status_code==0"
                     class="subBtn"
                     type="primary"
                     style="background: #4286f1;"
                     @click="spareBtn(1,'ruleForm',)">保存并开始</el-button>
          <el-button round
                     v-if="status_code==4||status_code==2"
                     class="subBtn"
                     type="primary"
                     style="background: #4286f1;"
                     @click="toSeats(0)">坐席执行</el-button>

        </div>
      </el-form>
    </section>
    <questionModal :isModal="isModal"
                   :contentType="showModalType"
                   :Modaldata='Modaldata'
                   @save="saveModal"
                   @cancel="cancelModals"></questionModal>
  </div>
</template>
<script>
import ImportExcel from './importExcel'
import channel from './channel'
import { Message, MessageBox } from 'element-ui'
import questionModal from '../common/quesModal.vue'
let qs = require('qs')
export default {
  name: 'editTask',
  props: {
    follwData: '',
  },
  data() {
    return {
      chooseFlag: '',
      invisible_group: [],
      invisible_group_ids: [],
      Modal_type: '',
      Modaldata: '',
      status_code: '',
      taskStatus: false,
      showOnePage: true,
      falg2: false,
      excel_temp_entities: [],
      editData: {},
      flag: false,
      channel_requests: {},
      selectType: {},
      checkList: [],
      showFollowObj: false,
      showModalType: 0,
      externalDdata: require('./creatTask.js').externalDdata,
      ObjList: [],
      tagList: [],
      ChannelData: [],
      typeCode: '',
      Radiovalue: {
        id: '',
        name: '',
        value: '',
      },
      Radiovalue2: {
        id: '',
        name: '',
        value: '',
      },
      isModal: false,
      typeLists: [],
      selectTypeCode: '',
      quesList: [],
      groupList: [
        {
          id: 0,
          name: '全部',
        },
      ],
      group: [],
      allNmuber: '',
      loading: true,
      diagnosis: '',
      age1: '',
      age2: '',
      groupTime: '',
      Chronic: [],
      executionTime: [],
      ruleForm: {
        executionTime: '',
        contents: '',
        signStatus: '',
        contentType: 1,
        name: '',
        region: '',
        typeListObj: '',
        questionnaires: '',
        task_follow: [],
        departmentvals: '',
        value1: '',
        value2: '',
        run_type: null,
        keep_holiday: '',
        valueTime: '',
        interval_unit: 3,
        push_interval: 1,
        frequency: 1,
        whether_deduplication: '',
        total_num: '',
        tag: [],
        sex: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入随访名称', trigger: 'blur' },
          {
            min: 3,
            max: 20,
            message: '长度在 3 到 20 个字符',
            trigger: 'blur',
          },
        ],
        contents: [
          { required: true, message: '请输入内容类型', trigger: 'change' },
        ],

        region: [
          { required: true, message: '请选择发起部门', trigger: 'change' },
        ],
        typeListObj: [
          { required: true, message: '请选择随类型', trigger: 'change' },
        ],
        questionnaires: [{ required: true, message: '请选择问卷' }],
        task_follow: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个随访对象',
          },
        ],
        departmentvals: [
          { required: true, message: '请选择执行部门', trigger: 'change' },
        ],
        executionTime: [
          { required: true, message: '请选择执行时间', trigger: 'change' },
        ],

        run_type: [
          { required: true, message: '请选执行方式', trigger: 'change' },
        ],
        frequency: [],
        push_interval: [],
        interval_unit: [],
        valueTime: [],
        total_num: [
          {
            required: true,
            type: 'number',
            trigger: 'blur',
            pattern: /.+/,
            message: '请输入执行人数',
          },
        ],
      },
      interval_unit: '日',
      questionnaires: '',
      questionnaire: [],
      beifen: [
        {
          value: 'ANSWER_PERCENT',
          label: '应答比例',
          disabled: false,
        },
        {
          value: 'ANSWER_NUM',
          label: '应答人数',
          disabled: false,
        },
      ],
      optionsList: [
        {
          select: [
            {
              value: 'ANSWER_PERCENT',
              label: '应答比例',
              disabled: false,
            },
            {
              value: 'ANSWER_NUM',
              label: '应答人数',
              disabled: false,
            },
          ],
        },
      ],
      push_interval: null,
      remark: '',
      run_type: null,
      task_follow: null,
      departmentList: [],
      followUpObj: [],
      typeListObj: null,
      valueTime: null,
    }
  },
  components: {
    ImportExcel,
    channel,
    questionModal,
  },
  computed: {
    windowHeight: function () {
      return window.innerHeight
    },
  },
  //
  mounted() {
    this.departmentList = this.$store.getters.curTeamList
    //     this.selectTypeCode = this.selectType.follow_code
    this.selectType.follow_code = this.follwData.follow_type_code
    this.selectTypeCode = this.follwData.follow_type_code

    this.selectType.follow_name = this.follwData.follow_type_name

    this.$utils.caringRequest({
      method: 'get',
      url:
        this.$utils.getInterface('TASK_DETAIL') +
        '/' +
        this.follwData.task_code,
      success: (res) => {
        console.log(res)
        if (res.data.taskStatus == 4) {
          this.taskStatus = true
        }

        this.status_code = res.data.task_status
        let entity = res.data.follow_person_entity
        console.log(806, res.data)
        this.chooseFlag = entity.choose_flag
        if (entity.choose_flag == 1) {
          this.showOnePage = false
          delete this.rules.region
        }
        this.editData = res.data
        if (this.selectType.follow_code == '1280315298171457536') {
          this.selectType.person_status = 0
        } else if (this.selectType.follow_code == '1280311473297559552') {
          this.selectType.person_status = 1
        } else if (this.selectType.follow_code == '1280309721538105344') {
          this.selectType.person_status = 1
        }

        if (entity) {
          this.selectType.person_status = entity.person_status
          this.Radiovalue2.id = entity.follow_type_code
          this.Radiovalue2.name = entity.question_name
          this.Radiovalue2.value = entity.question_name
          //    this.ruleForm.contents = res.data.follow_content_code

          if (entity.is_slow_center)
            this.diagnosis =
              entity.is_slow_center == -1 ? null : entity.is_slow_center + ''

          if (entity.filter_time) {
            this.groupTime = entity.filter_time.split(',')
          }
          if (entity.enter_time) {
            this.Chronic = entity.enter_time.split(',')
          }

          if (entity.sign_status != null)
            this.ruleForm.signStatus =
              entity.sign_status == -1 ? null : entity.sign_status + ''

          this.age1 = entity.age_start.split(',')[0]
          this.age2 = entity.age_start.split(',')[1]

          this.ruleForm.sex = entity.sex == -1 ? null : entity.sex + ''

          this.group = entity.patient_group == -1 ? null : entity.patient_group
        }

        if (
          this.selectType.person_status == 0 ||
          this.selectType.person_status == 1 ||
          this.selectType.person_status == 2
        ) {
          this.showFollowObj = true

          let query = {
            follow_type_code: this.selectTypeCode,
          }

          this.$utils.caringRequest({
            method: 'get',
            url:
              this.$utils.getInterface('QUERY_PERSON_TYPE') +
              '?' +
              qs.stringify(query),
            success: (res) => {
              this.followUpObj = res.data
              console.log(this.selectType.follow_name, res)
            },
          })
        }

        this.ruleForm.name = res.data.task_name
        this.ruleForm.region = res.data.dept_code

        this.ruleForm.departmentvals = res.data.run_dept_code
        if (res.data.task_follow_link_responses) {
          res.data.task_follow_link_responses.forEach((res) => {
            this.ruleForm.task_follow.push(res.follow_person_code)
          })
        }

        this.ruleForm.contentType = res.data.push_content_type
        console.log(797, this.ruleForm.contentType)
        if (!this.ruleForm.contentType) {
          this.ruleForm.contents = res.data.questionnaire_name
          this.Radiovalue.id = res.data.questionnaire_code
          this.Radiovalue.name = res.data.questionnaire_name
          this.Radiovalue.value = res.data.questionnaire_name
        } else {
          this.ruleForm.contents = res.data.follow_content_name
          this.Radiovalue.id = res.data.follow_content_code
          this.Radiovalue.name = res.data.follow_content_name
          this.Radiovalue.value = res.data.follow_content_name
        }

        this.ruleForm.executionTime = [res.data.start_time, res.data.end_time]
        this.ruleForm.run_type = res.data.run_type
        let channel_requests = {
          channel_requests: res.data.channel_requests,
          permission_type: res.data.permission_type,
          team_ids: res.data.team_ids,
        }
        this.channel_requests = channel_requests

        if (res.data.channel_requests.length) this.flag = true

        this.ruleForm.frequency = res.data.repeat_count
        //   this.ruleForm.push_interval = res.data.push_interval
        //   this.setinterval_unit(res.data.interval_unit)
        //   this.ruleForm.interval_unit = res.data.interval_unit
        this.ruleForm.total_num = res.data.total_num
        this.ruleForm.valueTime = res.data.push_time.substr(0, 5)
        console.log(res.data.task_agent_dimension_responses)

        if (res.data.excel_temp_entities.length) {
          this.excel_temp_entities = res.data.excel_temp_entities
          this.falg2 = true
        }

        if (res.data.patient_filter_entity_list.length) {
          this.falg2 = true
          this.excel_temp_entities = res.data.patient_filter_entity_list
        }

        let responses = res.data.task_agent_dimension_responses
        console.log(770, res.data.task_agent_dimension_responses)
        let referenceDimension = [
          {
            value: 'ANSWER_PERCENT',
            label: '应答比例',
            disabled: true,
          },
          {
            value: 'ANSWER_NUM',
            label: '应答人数',
            disabled: true,
          },
        ]
        let newarray = []
        responses.forEach((val, index) => {
          let obj = {}

          if (val.dimension_code == 'ANSWER_PERCENT') {
            console.log(val, 'ANSWER_PERCENT')
            obj.proportion = val.proportion * 100
            console.log(obj.proportion)
            let newa = JSON.parse(JSON.stringify(referenceDimension))
            newa[index].disabled = false

            obj.select = newa
            obj.dimension_code = val.dimension_code
            obj.dimension_name = val.dimension_name
            obj.dimension_value = val.proportion * 100

            newarray.push(obj)
          } else {
            let newa = JSON.parse(JSON.stringify(referenceDimension))
            newa[index].disabled = false
            obj.select = newa
            obj.dimension_code = val.dimension_code
            obj.dimension_name = val.dimension_name
            obj.dimension_value = val.dimension_value
            newarray.push(obj)
          }
          setTimeout((res) => {
            this.falg2 = true
            this.flag = true
            //     console.log(875)
          }, 500)
        })
        this.loading = false
        this.optionsList = newarray
        if (this.selectType.follow_code == '1280309721538105333') {
          this.getTags(1, 'GETGROUPLIST')
          this.getTag(1, 'GETGROUPLIST')
          this.getTag(1, 'GETTAGLIST')
        } else if (this.selectType.follow_code == '1280309721538105355') {
          this.getTag(0, 'GETGROUPLIST')
          this.getTag(0, 'GETTAGLIST')
          this.getTags(0, 'GETGROUPLIST')
        }
      },
    })
  },

  methods: {
    getTags(code, url) {
      this.$utils.caringRequest({
        method: 'get',
        url:
          this.$utils.getInterface(url) +
          '?type=' +
          code +
          '&page=1&size=20&need_page=0&invisible=1',
        success: (res) => {
          let group_id = this.editData.follow_person_entity.invisible_group_ids
          this.invisible_group = res.data
          this.invisible_group.forEach((val) => {
            val.id = val.id + ''
          })
          if (group_id) this.invisible_group_ids = group_id.split(',')

          console.log(1000, group_id)
          //   this.invisible_group_ids = [113]
        },
      })
    },
    saveModal(data) {
      if (data && data.length) {
        this.isModal = false
        console.log(this.Modal_type, data)
        if (this.Modal_type == 'wenjuan') {
          this.Radiovalue.name = data[0].questionnaire_name
          this.Radiovalue.value = data[0].questionnaire_name
          this.Radiovalue.id = data[0].questionnaire_id
          this.ruleForm.contents = data[0].questionnaire_name
        } else if (this.Modal_type == 'onlywenjuan') {
          this.Radiovalue2.name = data[0].questionnaire_name
          this.Radiovalue2.value = data[0].questionnaire_name

          this.Radiovalue2.id = data[0].questionnaire_id
        } else {
          this.Radiovalue.name = data[0].news_name
          this.Radiovalue.value = data[0].news_name
          this.Radiovalue.id = data[0].news_id
          this.ruleForm.contents = data[0].news_name
        }
      } else {
        this.$Message.warning('请选择筛查问卷')
      }
    },
    cancelModals() {
      this.isModal = false
    },
    toSeats() {
      let obj = {
        follow_person_code: this.editData.task_code,
        questionnaire_code: this.editData.questionnaire_code,
        task_code: this.editData.task_code,
        task_status: this.follwData.task_status,
      }
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'operate',
        title: '坐席执行',
        key: `operate?${obj.task_code}`,
        extra: {
          taskData: obj,
        },
      })
    },
    clickParent() {
      //     consolelo
      console.log(this.$refs.mychild.parentHandleclick())
    },
    quesData(data) {
      console.log(data)
    },
    getTag(code, url) {
      this.$utils.caringRequest({
        method: 'get',
        url: this.$utils.getInterface(url) + '?type=' + code,
        success: (res) => {
          if (url == 'GETTAGLIST') {
            this.tagList = res.data
            this.tagList.forEach((val) => {
              val.id = val.id + ''
            })

            if (this.editData.follow_person_entity.tags_id) {
              this.ruleForm.tag =
                this.editData.follow_person_entity.tags_id.split(',')
            }

            //     arr.forEach((val) => {
            //       val = Number(val)
            //     })
            console.log(867, this.ruleForm.tag)
          } else if (url == 'GETGROUPLIST') {
            this.groupList = this.groupList.concat(res.data)
          }
        },
      })
    },
    getcheck(flag) {
      if (flag) {
        let query
        let run_dept = {
            team_name: this.$store.state.shift.team_name,
            team_id: this.$store.state.shift.team_id,
          },
          dept_obj = run_dept,
          typeListObj

        typeListObj = this.selectType
        let arrs = []
        this.beifen.forEach((item) => {
          this.optionsList.forEach((value) => {
            if (value.dimension_code == item.value) {
              let obj = {}
              value.dimension_name = item.label
              if (value.dimension_code == 'ANSWER_PERCENT') {
                obj.proportion = value.dimension_value
                obj.dimension_name = value.dimension_name
                obj.dimension_code = value.dimension_code
              } else {
                obj.dimension_value = value.dimension_value
                obj.dimension_name = value.dimension_name
                obj.dimension_code = value.dimension_code
              }
              arrs.push(obj)
            }
          })
        })
        console.log(this.ruleForm.tag.toString())
        let age = [this.age1, this.age2]
        if (this.selectType.person_status == 4) {
          query = {
            patient_group: this.group == null ? -1 : this.group,
            tags_id: this.ruleForm.tag.toString(),
            filter_time: this.groupTime ? this.groupTime.toString() : '', //筛查时间
            sex: this.ruleForm.sex == null ? -1 : this.ruleForm.sex,
            enter_time: this.Chronic ? this.Chronic.toString() : '',
            question_code: this.Radiovalue2.id, //筛查问卷
            question_name: this.Radiovalue2.value, //筛查问卷
            push_content_type: this.ruleForm.contentType,
            is_slow_center: this.diagnosis == null ? -1 : this.diagnosis, //是否确诊
            start_time: this.ruleForm.executionTime[0] + ' 00:00:00',
            end_time: this.ruleForm.executionTime[1] + ' 23:59:59',
            run_dept_code: run_dept.team_id,
            run_dept_name: run_dept.team_name,
            dept_code: dept_obj.team_id,
            dept_name: dept_obj.team_name,
            follow_type_code: typeListObj.follow_code,
            follow_type_name: typeListObj.follow_name,
            task_dimension_link_requests: arrs,
            total_num: this.ruleForm.total_num,
            run_type: this.ruleForm.run_type,
            // questionnaire_code: 2305,
            age_start: age.toString(), //年龄段
            task_name: this.ruleForm.name,
            permission_type: this.ChannelData.VisibleValue, //可见范围
            team_ids: this.ChannelData.model10.toString(), //可见团队
            channels: this.ChannelData.channelList, //渠道
            task_status: this.task_status, //任务状态
            choose_flag: this.chooseFlag, //有人1，无人0
            person_status: typeListObj.person_status, //对象类型
            excel_temp_entities: this.ObjList,
            invisible_group_ids: this.invisible_group_ids.toString(),
          }
        } else if (this.selectType.person_status == 5) {
          query = {
            invisible_group_ids: this.invisible_group_ids.toString(),
            excel_temp_entities: this.ObjList,
            sign_status:
              this.ruleForm.signStatus == null ? -1 : this.ruleForm.signStatus,
            tags_id: this.ruleForm.tag.toString(),
            // filter_time: this.groupTime.toString(),
            enter_time: this.Chronic ? this.Chronic.toString() : '',
            // question_code: this.group.toString(),
            follow_content_code: this.Radiovalue.id,
            follow_content_name: this.Radiovalue.name,
            patient_group:
              this.group == null || this.group == '' ? -1 : this.group,
            push_content_type: this.ruleForm.contentType,
            // isSlow_center: this.diagnosis,
            start_time: this.ruleForm.executionTime[0] + ' 00:00:00',
            end_time: this.ruleForm.executionTime[1] + ' 23:59:59',
            run_dept_code: run_dept.team_id,
            run_dept_name: run_dept.team_name,
            dept_code: dept_obj.team_id,
            dept_name: dept_obj.team_name,
            follow_type_code: typeListObj.follow_code,
            follow_type_name: typeListObj.follow_name,
            task_dimension_link_requests: arrs,
            total_num: this.ruleForm.total_num,
            run_type: this.ruleForm.run_type,
            // questionnaire_code: 2305,
            // age_start: age.toString(),
            task_name: this.ruleForm.name,
            permission_type: this.ChannelData.VisibleValue, //可见范围
            team_ids: this.ChannelData.model10.toString(), //可见团队
            channels: this.ChannelData.channelList, //渠道
            task_status: this.task_status, //任务状态
            choose_flag: this.chooseFlag, //有人1，无人0
            person_status: typeListObj.person_status, //对象类型
          }
        }
        query.task_code = this.follwData.task_code
        if (this.ruleForm.run_type == 0 || this.ruleForm.run_type == 3) {
          let myDate = new Date()
          let mm = myDate.getMinutes()
          const times = myDate.getHours() + ':' + mm

          let cData = new Date(
            this.ruleForm.executionTime[0] + ' ' + this.ruleForm.valueTime
          ).getTime()
          let tData = new Date().getTime()
          if (cData < tData && this.task_status == 1) {
            Message({
              type: 'warning',
              message: '推送时间不能小于当前时间',
            })
            return
          }
          let acData = arrs.find((x) => x.dimension_code == 'ANSWER_NUM')
          console.log(acData)
          if (this.optionsList.length > 1) {
            let calculation = arrs.find(
              (x) => x.dimension_code == 'ANSWER_PERCENT'
            )
            let ANSWER_NUM = this.optionsList.find(
              (x) => x.dimension_code == 'ANSWER_NUM'
            )
            console.log(calculation)
            this.allNmuber =
              (this.ruleForm.total_num * calculation.proportion) / 100
            if (this.allNmuber != acData.dimension_value) {
              console.log(this.allNmuber, 'anum', acData)
              ANSWER_NUM.dimension_value = this.allNmuber
              MessageBox.alert(
                '应答人数必须等于计划推送人数*应答比例',
                '应答人数有误',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {
                    this.next('flag')
                  },
                }
              )
              return
            }
          }
          if (acData) {
            if (
              this.ruleForm.total_num < acData.dimension_value &&
              this.ruleForm.total_num
            ) {
              Message({
                type: 'warning',
                message: '计划推送人数不能小于应答人数',
              })
              return
            }
          } else {
            query.total_num = this.ruleForm.total_num
          }

          query.push_time = this.ruleForm.valueTime + ':00'
          query.interval_unit = this.ruleForm.interval_unit
          query.push_interval = this.ruleForm.push_interval
          query.repeat_count = this.ruleForm.frequency
        } else {
          query.total_num = ''
        }
        if (this.ruleForm.contentType) {
          query.follow_content_code = this.Radiovalue.id
          query.follow_content_name = this.Radiovalue.name
        } else {
          query.questionnaire_code = this.Radiovalue.id
          query.questionnaire_name = this.Radiovalue.name
        }

        //       console.log(obj)
        console.log(query)
        this.loading = true
        this.$utils.caringRequest({
          method: 'put',
          url: this.$utils.getInterface('CREATE_TASK_INFO'),
          data: query,
          success: (res) => {
            this.loading = false
            if (res.code == 0) {
              this.refesh()
              this.$store.commit('setActiveKey', `typeManagement`)
              this.$store.commit('setAllSelectedKeys', {
                type: 'delete',
                name: 'editTask',
                // title: '创建随访任务',
                key: `editTask?${this.follwData.task_code}`,
              })
            } else {
              Message.warning({
                message: res.message,
              })
            }
          },
        })
      }
    },
    getChannelData(data) {
      console.log(data)
      this.ChannelData = data
    },
    getObjList(list) {
      this.ObjList = list
    },
    groupSelect() {
      this.showModalType = 0
      this.Modaldata = ''
      this.Modal_type = 'onlywenjuan'
      this.isModal = true
    },
    contentSelect() {
      this.isModal = true
      this.showModalType = this.ruleForm.contentType
      this.Modaldata = qs.stringify({
        disease_id: this.$store.state.shift.disease_id,
        follow_type_code: this.selectType.follow_code,
      })

      if (this.ruleForm.contentType == 1) {
        this.Modal_type = 'xuanjiao'
      } else {
        this.Modal_type = 'wenjuan'
      }
    },

    submit() {
      this.isModal = false
      console.log(this.showModalType)

      if (this.showModalType == 'wenjuan') {
        this.Radiovalue.name = this.Radiovalue.value
        this.ruleForm.contents = this.Radiovalue.value
      } else if (this.showModalType == 'onlywenjuan') {
        this.Radiovalue2.name = this.Radiovalue.val
      } else {
        this.Radiovalue.name = this.Radiovalue.value
        this.ruleForm.contents = this.Radiovalue.value
      }
      console.log(this.Radiovalue, this.Radiovalue2)
    },
    cancel() {
      this.isModal = false
    },
    selectRadio(data) {
      console.log(data)
      if (this.showModalType == 'wenjuan') {
        this.Radiovalue.value = data.questionnaire_name
        this.ruleForm.contents = data.questionnaire_name
        this.Radiovalue.id = data.questionnaire_id
      } else if (this.showModalType == 'onlywenjuan') {
        this.Radiovalue2.value = data.questionnaire_name
        this.Radiovalue2.id = data.questionnaire_id
      } else {
        this.Radiovalue.value = data.news_name
        this.ruleForm.contents = data.news_name
      }
      //       console.log()
    },

    getContentType(e) {
      this.Radiovalue = {
        id: '',
        name: '',
        value: '',
      }
      this.ruleForm.contents = ''
    },
    getquestionnaire(id) {
      var self = this
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUES_NEWS'),
        data: {
          category_id: id,
        },
        success: function (res, response) {
          if (res.code === 0) {
            self.questionnaire = res.data
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    getQuesList(id, type) {
      var self = this
      self.haveData = false
      let url
      if (this.showModalType == 'wenjuan') {
        url = self.$utils.getInterface('QUES_NEWS')
      } else {
        url = self.$utils.getInterface('EHOSPITAL_NEWS')
      }
      self.$utils.caringRequest({
        method: 'GET',
        url: url,
        data: {
          category_id: id,
        },
        success: function (res, response) {
          if (res.code === 0) {
            self.questionnaire = res.data
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    spareBtn(task_status) {
      this.task_status = task_status
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$refs.mychild.parentHandleclick()
        }
      })

      //     patientFilterEntityList  带人 excelTempEntities
    },

    setInterval_unit(e) {
      if (e == 3) {
        this.interval_unit = '天'
      } else if (e == 2) {
        this.interval_unit = '周'
      } else if (e == 1) {
        this.interval_unit = '月'
      }
    },
    selectQues(value, selectedData) {
      console.log(value, selectedData)
      this.quesId = selectedData[1].questionnaire_id
      // this.type_id = selectedData[1].type_id
      // this.questionnaire_name = selectedData[1].name
    },
    changeSelect(event) {
      if (event) {
        this.getDept()
        // this.getPerson()
      }
    },
    proving1(e) {
      var str = e.target.value
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      var keynum = window.event ? e.keyCode : e.which //获取键盘码
      var keychar = String.fromCharCode(keynum) //获取键盘码对应的字符
      if (keynum == 189 || keynum == 190 || keynum == 109 || keynum == 69) {
        // this.$Message.warning('禁止输入小数以及负数')
        e.target.value = ' '
      }
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        e.target.value = str.substr(1, 1)
      }
    },

    oninput(num) {
      var str = num
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        str = str.substr(1, 1)
      }
      //第一位不能是.
      if (len1 == '.') {
        str = ''
      }
      //限制只能输入一个小数点
      if (str.indexOf('.') != -1) {
        var str_ = str.substr(str.indexOf('.') + 1)
        if (str_.indexOf('.') != -1) {
          str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
        }
      }
      console.log(num > 100)

      if (num > 100) {
        num = ''
        return num
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
      str = str.replace(/\.\d\d\d$/, '') // 小数点后只能输两位
      return str
    },

    types(val) {
      if (val == 0) {
        this.rules.valueTime = [
          { required: true, message: '推送时间', trigger: 'change' },
        ]
      } else {
        delete this.rules.valueTime

        this.ruleForm.run_type = val
      }
      console.log(this.rules)
    },

    getChangeVal(ind, val, $event) {
      if (this.optionsList[ind].dimension_value) {
        this.optionsList[ind].dimension_value = null
      }

      if (!ind) {
        this.beifen.forEach((val) => {
          if (val.value == this.optionsList[ind].dimension_code) {
            val.disabled = true
          } else {
            val.disabled = false
          }
        })
      } else {
        this.optionsList[0].select.forEach((val) => {
          if (val.value == this.optionsList[ind].dimension_code) {
            val.disabled = true
          }
        })
      }
    },
    delet(ind) {
      this.optionsList.splice(ind, 1)
      console.log(this.optionsList)
      this.optionsList[0].select.forEach((res) => {
        res.disabled = false
      })
      console.log(this.optionsList)
    },
    addStandard() {
      if (this.optionsList.length < 2) {
        let obj = {
          select: this.beifen,
        }
        console.log(obj)
        this.optionsList.push(obj)
      } else {
        Message({
          type: 'warning',
          message: '目前只能添加两条参考维度',
        })
      }
    },

    saveBtn(task_status, formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let depObj = {
              team_name: this.$store.state.shift.team_name,
              team_id: this.$store.state.shift.team_id,
            },
            depObjs = run_dept,
            typeListObj

          typeListObj = this.selectType

          let array = [
            {
              code: 'name',
              value: '隐藏姓名',
            },
            {
              code: 'tel',
              value: '隐藏电话',
            },
            {
              code: 'questionnaire',
              value: '隐藏答卷',
            },
          ]

          let newArray = []
          this.checkList.forEach((val, ind) => {
            array.forEach((value, index) => {
              if (value.value == val) {
                newArray.push(value.code)
              }
            })
          })
          let arrs = []
          this.beifen.forEach((item) => {
            this.optionsList.forEach((value) => {
              if (value.dimension_code == item.value) {
                let obj = {}
                value.dimension_name = item.label
                if (value.dimension_code == 'ANSWER_PERCENT') {
                  obj.proportion = value.dimension_value
                  obj.dimension_name = value.dimension_name
                  obj.dimension_code = value.dimension_code
                } else {
                  obj.dimension_value = value.dimension_value
                  obj.dimension_name = value.dimension_name
                  obj.dimension_code = value.dimension_code
                }
                arrs.push(obj)
              }
            })
          })

          let query = {
            channels: this.ChannelData.channelList, //渠道
            dept_code: depObj.team_id,
            dept_name: depObj.team_name,
            task_name: this.ruleForm.name,
            follow_type_code: typeListObj.follow_code,
            follow_type_name: typeListObj.follow_name,
            task_follow_link_requests: [],
            run_dept_code: depObjs.team_id,
            run_dept_name: depObjs.team_name,
            start_time: this.ruleForm.executionTime[0] + ' 00:00:00',
            end_time: this.ruleForm.executionTime[1] + ' 23:59:59',
            run_type: this.ruleForm.run_type,
            task_status: task_status,
            remark: this.remark,
            push_content_type: this.ruleForm.contentType,
            private_options: newArray.toString(),
            task_dimension_link_requests: arrs,
            excel_temp_entities: this.ObjList,
            whether_deduplication: this.ruleForm.whether_deduplication
              ? true
              : false,
            total_num: this.ruleForm.total_num,
            choose_flag: '0', //有人1，无人0
            permission_type: this.ChannelData.VisibleValue, //可见范围
            team_ids: this.ChannelData.model10.toString(), //可见团队
            person_status: typeListObj.person_status, //对象类型
          }

          if (this.ruleForm.run_type == 0 || this.ruleForm.run_type == 3) {
            let myDate = new Date()
            let mm = myDate.getMinutes()
            const times = myDate.getHours() + ':' + mm

            let cData = new Date(
              this.ruleForm.executionTime[0] + ' ' + this.ruleForm.valueTime
            ).getTime()
            let tData = new Date().getTime()
            if (cData < tData && task_status == 1) {
              Message({
                type: 'warning',
                message: '推送时间不能小于当前时间',
              })
              return
            }
            let acData = arrs.find((x) => x.dimension_code == 'ANSWER_NUM')
            console.log(acData)
            if (this.optionsList.length > 1) {
              let calculation = arrs.find(
                (x) => x.dimension_code == 'ANSWER_PERCENT'
              )
              let ANSWER_NUM = this.optionsList.find(
                (x) => x.dimension_code == 'ANSWER_NUM'
              )
              console.log(calculation)
              this.allNmuber =
                (this.ruleForm.total_num * calculation.proportion) / 100
              if (this.allNmuber != acData.dimension_value) {
                console.log(this.allNmuber, 'anum', acData)
                ANSWER_NUM.dimension_value = this.allNmuber
                MessageBox.alert(
                  '应答人数必须等于计划推送人数*应答比例',
                  '应答人数有误',
                  {
                    confirmButtonText: '确定',
                    callback: (action) => {
                      this.next('flag')
                    },
                  }
                )
                return
              }
            }
            if (acData) {
              if (
                this.ruleForm.total_num < acData.dimension_value &&
                this.ruleForm.total_num
              ) {
                Message({
                  type: 'warning',
                  message: '计划推送人数不能小于应答人数',
                })
                return
              }
            } else {
              query.total_num = this.ruleForm.total_num
            }

            query.push_time = this.ruleForm.valueTime + ':00'
            query.interval_unit = this.ruleForm.interval_unit
            query.push_interval = this.ruleForm.push_interval
            query.repeat_count = this.ruleForm.frequency
          } else {
            query.total_num = ''
          }
          this.ruleForm.task_follow.forEach((val, ind) => {
            this.followUpObj.forEach((value, index) => {
              if (value.follow_person_code == val) {
                query.task_follow_link_requests.push(value)
              }
            })
          })
          if (this.ruleForm.contentType) {
            query.follow_content_code = this.Radiovalue.id
            query.follow_content_name = this.Radiovalue.name
          } else {
            query.questionnaire_code = this.Radiovalue.id
            query.questionnaire_name = this.Radiovalue.name
          }
          this.loading = true
          this.$utils.caringRequest({
            method: 'post',
            url: this.$utils.getInterface('CREATE_TASK_INFO'),
            data: query,
            success: (res) => {
              this.loading = false
              if (res.code == 0) {
                this.refesh()
                this.$store.commit('setActiveKey', `typeManagement`)
                this.$store.commit('setAllSelectedKeys', {
                  type: 'delete',
                  name: 'editTask',
                  //   title: '创建随访任务',
                  key: `editTask?${this.follwData.task_code}`,
                })
              } else {
                Message.warning({
                  message: res.message,
                })
              }
              //       console.log(res)
            },
          })

          console.log(query)
        } else {
          console.log('error submit!!')
        }
      })
    },
    refesh() {
      const list = this.$store.state.allSelectedKeys.map((l) => {
        if (l.key === 'typeManagement') {
          l.refesh = true
        }
        return l
      })
      this.$store.commit('setAllSelectedKeys', {
        type: 'allAdd',
        list,
      })
      setTimeout(() => {
        const list = this.$store.state.allSelectedKeys.map((l) => {
          if (l.key === 'typeManagement') {
            l.refesh = false
          }
          return l
        })
        this.$store.commit('setAllSelectedKeys', {
          type: 'allAdd',
          list,
        })
      }, 400)
    },
  },
}
</script>
<style lang="less" scoped>
.tipsty {
  font-size: 12px;
  color: #606266;
  opacity: 0.6;
  display: inline-block;
  width: 326px;
  left: 98px;
  position: relative;
  top: -19px;
}
.tipsty2 {
  padding-left: 80px;
  font-size: 12px;
  display: inline-block;
  //   width: 290px;

  position: relative;
  color: #606266;
  opacity: 0.6;
  top: 185px;
  position: absolute;
}
.PERCENT {
  position: relative;
  left: -25px;
}
.el-input {
  width: 217px !important;
}
.ckquestionnaire {
  color: #4286f1;
  margin-top: 8px;
  font-size: 14px;
  display: inline-block;
  font-weight: normal;
  cursor: pointer;
}
.duplicate {
  //   width: 320px;
}
.sp_left {
  padding-left: 8px;
}
body {
  margin: 0;
}
.ckinput {
  width: 200px;
  height: 40px;
  padding-left: 15px;
  padding-top: 2px;
  border: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
input::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #bdcada;
}

.setPush {
  line-height: 32px;

  color: #606266;
}
.quest-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(234, 238, 247, 1);
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(116, 130, 154, 1);
  padding-left: 30px;
}
.addStandard {
  margin-left: 925px;
}
.elerror {
  float: right;
  font-size: 24px;
  margin-top: 18px;
  padding-right: 20px;
  color: #afbed3;
}

.dimension_o {
  width: 1100px;
  height: 64px;
  line-height: 64px;
  background: rgba(240, 246, 255, 1) !important;
  border-radius: 6px;
  padding-left: 20px;
}

.subBtn {
  padding: 12px;
  //   width: 90px;

  //   background: rgba(66, 134, 241, 1);
  //  border-radius: 8px;
}
.creat-type-tit_o {
  font-weight: bold;

  color: rgba(255, 175, 21, 1);
}
.shuxian_o {
  display: inline-block;
  width: 4px;
  height: 15px;
  background: rgba(255, 175, 20, 1);
  border-radius: 2px;
}
#createNewObject_o {
  background-color: #f8f8ff;
  // padding: 20px 16px;
  font-size: 16px;
  .el-row {
    background: #ffffff;
    margin-top: 12px;
  }
}
.padleft {
  padding-left: 10px;
}
.namebox {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
